import { UI, HStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { OrderStatusProps } from '../../../../utils/getValidatedStatusIcon';

export interface OrderFullStatusProps {
  statusIcon: OrderStatusProps;
  statusMessage?: string | null;
}

export const OrderFullStatus: React.FC<OrderFullStatusProps> = ({ statusIcon, statusMessage }) => {
  return (
    <HStack space={Spacing['inline.quarck']} alignItems="center">
      <UI.IconStatus
        testId="icon-status"
        bgColor={statusIcon.backgroundColor}
        icon={statusIcon.icon}
        color={statusIcon.iconColor}
        size={statusIcon.iconSize}
      />
      {!!statusMessage && <UI.Text textTransform="uppercase">{statusMessage}</UI.Text>}
    </HStack>
  );
};
